import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestComprensioneEditComponent.vue?vue&type=template&id=51f4ea1a&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestComprensioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestComprensioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestComprensioneEditComponent.vue?vue&type=style&index=0&id=51f4ea1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f4ea1a",
  null
  
)

export default component.exports